import { Link } from "react-router-dom";
import { MessageCircle, Mail, MapPin } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { CONTACT } from "@/i18n/translations";

const Footer = () => {
  const { t } = useLanguage();
  const year = new Date().getFullYear();

  return (
    <footer className="bg-ink text-sand" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <p className="font-serif text-2xl font-semibold">
            Marina <span className="italic text-terracotta-soft">Knows</span>
          </p>
          <p className="mt-3 text-sand/70 max-w-sm">{t.footer.tagline}</p>
          <p className="mt-6 inline-flex items-center gap-2 text-sm text-sand/60 font-mono">
            <MapPin size={14} aria-hidden /> {t.footer.area}
          </p>
        </div>

        <div className="md:col-span-3">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-sand/50 mb-4">{t.footer.nav}</p>
          <ul className="space-y-2.5">
            {[
              ["about", "/about"],
              ["services", "/services"],
              ["pricing", "/pricing"],
              ["faq", "/faq"],
              ["blog", "/blog"],
            ].map(([key, to]) => (
              <li key={key}>
                <Link to={to} data-testid={`footer-${key}`} className="text-sand/75 hover:text-terracotta-soft transition-colors text-sm">
                  {t.nav[key]}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-sand/50 mb-4">{t.footer.contactTitle}</p>
          <ul className="space-y-3 text-sm">
            <li>
              <a href={CONTACT.whatsapp} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp"
                 className="inline-flex items-center gap-2 text-sand/75 hover:text-terracotta-soft transition-colors">
                <MessageCircle size={15} aria-hidden /> {CONTACT.phoneDisplay}
              </a>
            </li>
            <li>
              <a href={`mailto:${CONTACT.email}`} data-testid="footer-email"
                 className="inline-flex items-center gap-2 text-sand/75 hover:text-terracotta-soft transition-colors">
                <Mail size={15} aria-hidden /> {CONTACT.email}
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-sand/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col sm:flex-row justify-between gap-2 text-xs text-sand/50 font-mono">
          <span>© {year} Marina Knows · marinaknows.com — {t.footer.rights}</span>
          <span>{t.footer.madeIn}</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
